import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHelp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M22 36h4v-4h-4zm2-32C12.96 4 4 12.96 4 24s8.96 20 20 20 20-8.96 20-20S35.04 4 24 4m0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16m0-28c-4.42 0-8 3.58-8 8h4c0-2.2 1.8-4 4-4s4 1.8 4 4c0 4-6 3.5-6 10h4c0-4.5 6-5 6-10 0-4.42-3.58-8-8-8" })
});
export default SvgHelp;
